export default "__VITE_ASSET__CWIucd9y__"